import { useMutation } from '@tanstack/react-query';
import { processTerminalPayment } from '../../services/payments';

interface Args {
  onSuccess?: (
    result: Awaited<ReturnType<typeof processTerminalPayment>>,
  ) => void;
  onError?: (error: Error) => void;
}

function useProcessTerminalPayment({ onSuccess, onError }: Args = {}) {
  return useMutation({
    mutationFn: processTerminalPayment,
    onSuccess,
    onError,
  });
}

export default useProcessTerminalPayment;
